<template>
<div class="container">
    <PauseModal v-if="modal_pause" @restart="
        modal_pause = !modal_pause;
        reset=true;
        play=true;
        playMusic = !playMusic;
        play_recording();
      " @closeModal="
        modal_pause = !modal_pause;
        reset=true;
        finish_play();
      " @resume="
        modal_pause = !modal_pause;
        reset=false;
        play=true;
        playMusic = !playMusic;
        play_recording();
      " />
    <Congratulations v-if="congrats_modal" @restart="congrats_modal = !congrats_modal;" @saveGame="$emit('onSavingGame', recorded_blob, velocity); congrats_modal = !congrats_modal;" @backToMenu="$emit('backToMenu');" />

    <div v-show="onCount" id="singing-counting" class="singing-counting">
        <h1 id="singing-count-number" class="singing-count-number"> 3 </h1>
    </div>

    <div id="singing-container" class="container-2">
        <div class="score-container-singing">
            <PhraseDisplay :phrase="beats" :levels="curve" />
        </div>
        <div id="score-container-singing-canvas" class="score-container-singing-canvas">
            <canvas :id="'canvas-score'" class="canvas"></canvas>
        </div>
        <div id="singing-playing-bar" class="playing-line" :class="{'active': active}"></div>
    </div>
    <MidiPlayer :midi="midi" :playMidi="playMusic" :velocity="velocity" @finishedPlaying="finish_play" :reset="reset" @currentPosition="viewPosition"></MidiPlayer>
    <p class="hidden"><audio id="audio" controls></audio></p>

    <div>
        <div class="complete-melody tamanhoicon" @click="finish">
            <img :src="require('@/assets/buttons/newbuttons/sing/submit.svg')" />
        </div>

        <div>
            <img id="speedbarcaracol" :src="require('@/assets/buttons/newbuttons/speedbar/caracoldanca.svg')" />
            <img id="speedbarcoelho" :src="require('@/assets/buttons/newbuttons/speedbar/coelhodanca.svg')" />
        </div>
        <div id="speedbar_play" class="tamanhoicon speed-bar">

            <input type="range" min="0.25" max="2.0" step="0.25" list="tickmarks" v-model="velocity" class="slider" id="Speed-Range-Sing">
            <datalist id="tickmarks">
                <option value="0.25"></option>
                <option value="0.5" label="0.5"></option>
                <option value="0.75"></option>
                <option value="1.0" label="1"></option>
                <option value="1.25"></option>
                <option value="1.5" label="1.5"></option>
                <option value="1.75"></option>
                <option value="2.0" label="2"></option>
            </datalist>
        </div>

        <div class="play-sing tamanhoicon">
            <img @click="play_pause" :src="require('@/assets/buttons/newbuttons/sing/pause.svg')" v-if="play" />
            <img @click="play_pause" :src="require('@/assets/buttons/newbuttons/sing/play.svg')" v-else />
        </div>
        <div class="instrument-mute-sing tamanhoicon" :class="[muted ? 'muted' : '']" id="Mute-Original" @click="muted = !muted">
            <img :src="require('@/assets/buttons/newbuttons/mute/mutesing.svg')" v-if="muted==true">
            <img :src="require('@/assets/buttons/newbuttons/mute/unmutesing.svg')" v-else>
        </div>
        <div class="voice-mute-sing tamanhoicon" :class="[muted ? 'muted' : '']" id="Mute-Original" @click="play_recorded = !play_recorded">
            <img :src="require('@/assets/buttons/newbuttons/mute/mutesing.svg')" v-if="play_recorded==false">
            <img :src="require('@/assets/buttons/newbuttons/mute/unmutesing.svg')" v-else>
        </div>
        <div class="record-sing tamanhoicon" @click="record_stop">
            <img :src="require('@/assets/buttons/newbuttons/sing/recording.svg')" v-if="recording" />
            <img :src="require('@/assets/buttons/newbuttons/sing/record.svg')" v-else />
        </div>
        <div @click="back_phrase('slow')" id="back" class="tamanhoicon" :disabled="back_arrow_disabled">
            <img :src="require('@/assets/buttons/newbuttons/sing/seta_esq.svg')" />
        </div>
        <div @click="next_phrase('slow')" id="forward" class="tamanhoicon" :disabled="next_arrow_disabled">
            <img :src="require('@/assets/buttons/newbuttons/sing/seta_drt.svg')" />
        </div>
    </div>
</div>
</template>

<script>
import MidiPlayer from "../General/MidiPlayer.vue";
import PhraseDisplay from "@/components/SingingGame/PhraseDisplay.vue";
import PauseModal from "@/components/SingingGame/PauseModal.vue";
import Congratulations from "@/components/SingingGame/Congratulations.vue";

export default {
    name: "Score",
    emits: ['backToMenu', 'restart', 'onSavingGame'],
    components: {
        MidiPlayer,
        PhraseDisplay,
        PauseModal,
        Congratulations,

    },
    created() {
        window.addEventListener("resize", this.resize);
    },
    mounted() {
        this.resize();
    },
    data() {
        return {
            play_recorded: true,
            muted_record: false,
            play: false,
            playMusic: false,
            midi: "",
            reset: false,
            active: false,

            recorder: null,
            recording: false,
            recorded: null,
            recorded_blob: null,

            onCount: false,
            counter: false,
            ct: 3,

            currentScroll: 0,
            muted: false,
            velocity: 1.0,

            current_phrase: 0,
            n_phrase: 3,

            modal_pause: false,
            congrats_modal: false,
            alert_modal: false,

            next_arrow_disabled: false,
            back_arrow_disabled: true,

            curve: [],
            beats: [],
            coord: []
        };
    },
    props: {
        phrases: Object,
    },
    methods: {
        finish() {
            this.congrats_modal = true;
            this.play = false;
            this.playMusic = false;
        },
        resize() {
            this.calculateCurves();
            this.drawPhrase();
        },
        calculateCurves() {
            let beats = Object.values(this.phrases.music);
            this.curve = beats.map((e) => {
                if (e['notes'][0][3] != 0) return e['notes'][0][3];
                let poss = e['notes'].map((e1) => {
                    return e1[3]
                });
                let non_zero = poss.find((value) => value !== 0);
                if (non_zero !== undefined) return non_zero;
                return 2;
            });
            this.beats = beats;
            let notes_beat = this.beats.map((e) => {
                return e['notes'].length
            });
            let max_notes_beat = notes_beat.reduce(function (a, b) {
                return Math.max(a, b);
            }, -Infinity);
            this.coord = this.calculateCurveFromPoints(this.curve, max_notes_beat);
        },
        calculateCurveFromPoints(points, max_notes_beat) {

            let division = 10/max_notes_beat;
            let width = window.innerWidth * ((points.length + 1) / division);
            let height = window.innerHeight;

            let div_w = width / (points.length + 1);
            let div_h = height / 8;

            let line_3 = [];

            line_3.push({
                x: 0,
                y: height / 2.0,
            });

            let last_x = 0;
            for (let j = 0; j < points.length; j++) {
                last_x += div_w;

                let num = points[j];
                let y = num * div_h;
                if (num == 1) {
                    y -= div_h / 6.0;
                }
                if (num == 3) {
                    y += div_h / 6.0;
                }

                line_3.push({
                    x: last_x,
                    y: y,
                });
            }

            line_3.push({
                x: last_x + div_w,
                y: height / 2.0,
            });

            let maxArray = Math.max.apply(null, line_3.map(function (el) {
                return el.y + 1.75 * div_h
            }));
            let minArray = Math.min.apply(null, line_3.map(function (el) {
                return el.y + 0.25 * div_h
            }));
            if (maxArray > window.innerHeight) {
                line_3 = line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y - (window.innerHeight - maxArray) - 5
                    }
                });
            } else if (minArray < window.innerHeight / 9.0) {
                line_3 = line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + (window.innerHeight / 9.0)
                    }
                });
            }

            return {
                line_1: line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + 0.25 * div_h,
                    };
                }),
                line_2: line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + div_h,
                    };
                }),
                line_3: line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + 1.75 * div_h,
                    };
                }),
            };
        },
        drawPhrase() {
            let canvas = document.getElementById("canvas-score");
            let cv_rect = canvas.getBoundingClientRect();

            let ctx = canvas.getContext("2d");

            cv_rect.width = this.coord['line_1'][this.coord['line_1'].length - 1].x;
            ctx.canvas.width = this.coord['line_1'][this.coord['line_1'].length - 1].x;
            canvas.width = this.coord['line_1'][this.coord['line_1'].length - 1].x;
            canvas.height = cv_rect.height;

            ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            for (let line in this.coord) {
                this.draw_curve_aux(ctx, this.coord[line], 0.9, '#FFFFFF', 3);
            }
            setTimeout(() => {
                this.adjust_positions('line_2');
            })
        },
        adjust_positions(line) {
            let coord = this.coord[line].slice(1, this.coord[line].length - 1);

            let maxY = Math.max.apply(null, this.coord[line].slice(1, this.coord[line].length - 1).map(function (el) {
                return el.y
            }));

            // Beats
            for (let j = 0; j < coord.length; j++) {

                let cd = coord[j];

                let div = document.getElementById("Beat-" + j.toString());
                let width = 10;

                if (div != null) {
                    div.style.position = "absolute";
                    div.style.left = cd.x - (div.clientWidth / 4.0) + 'px';
                    div.style.top = cd.y - (div.clientHeight / 2.0) + 'px';
                    width = div.offsetWidth;
                }

                let lycs = document.getElementById("Beat-Lyc-" + j.toString());

                if (lycs != null) {
                    lycs.style.position = "absolute";
                    lycs.style.left = cd.x - (div.clientWidth / 2) + 'px';
                    lycs.style.top = maxY + 60 + 'px';
                    lycs.style.width = width + 'px';
                }
            }

        },
        play_pause() {
            if (this.play) {
                this.popup_pausa();
            } else {
                this.play_music();
            }
        },
        record_stop() {
            if (this.recording) {
                this.reset = false;
                this.playMusic = !this.playMusic;
                this.finish_play();
            } else {
                this.startCount();
            }
        },
        play_recording() {
            /* if (this.recorded !== null && !this.recording && this.play.recorded) {
                 let audio = document.getElementById('audio');
                 if (this.reset) {
                     audio.currentTime = 0;
                 }
                 audio.play();
             }   */
            let audio = document.getElementById('audio');
            if (this.play_recorded) {

                if (this.recorded !== null && !this.recording) {

                    if (this.reset) {
                        audio.currentTime = 0;
                    }
                    audio.play();
                }
            } else {
                audio.pause();
            }

        },
        popup_pausa() {
            this.modal_pause = !this.modal_pause;
            this.play = false;

            if (this.recorded) {
                let audio = document.getElementById('audio');
                audio.pause();
            }
            this.playMusic = !this.playMusic;
        },
        finish_play() {
            this.play = false;
            let container = document.getElementById("singing-container");
            container.scrollTo(0, 0);
            this.active = false;

            if (this.recorded && !this.recording) {
                let audio = document.getElementById('audio');
                audio.pause();
            }
            this.on_stop_recording();
        },
        viewPosition(pos) {

            let canvas = document.getElementById("canvas-score");
            let container = document.getElementById("singing-container");
            let temp_scroll = 0;

            if (pos !== 'Not Playing') {
                this.active = true;

                let div = document.getElementById('singing-playing-bar');
                let canvas_width = canvas.width;

                if (div != null) {

                    let posX = pos * canvas_width;
                    div.style.position = "absolute";
                    div.style.left = posX + 'px';

                    if ((posX > window.innerWidth / 2.0) && ((posX - 0.125 * this.currentScroll) > Math.ceil(window.innerWidth / 2.0))) {
                        temp_scroll = posX - Math.ceil(window.innerWidth / 2.0);
                        if ((temp_scroll - this.currentScroll) < Math.ceil(window.innerWidth / 3.0)) {
                            temp_scroll = this.currentScroll;
                        }
                    }
                }

            } else {
                this.active = false;
                temp_scroll = 0;
            }

            if (this.currentScroll !== temp_scroll) {
                container.scrollTo(temp_scroll, 0);
                this.currentScroll = temp_scroll;
            }
        },
        back_phrase(mode = 'slow') {
            let canvas = document.getElementById("canvas-score");
            let container = document.getElementById("singing-container");

            if (mode === 'fast') {
                let width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
                let num_phrases = Math.ceil(canvas.width / width);
                for (let i = 0; i < num_phrases; i++) {
                    if ((container.scrollLeft >= i * width && i > 0) && container.scrollLeft <= (i + 1) * width) {
                        container.scrollTo((i - 1) * width, 0);
                        break;
                    }
                }
            } else {
                if (container.scrollLeft > 0) {
                    container.scrollTo(container.scrollLeft - canvas.width / 10.0, 0);
                }
            }
            this.enable_buttons(container, canvas);
        },
        next_phrase(mode = 'slow') {
            let canvas = document.getElementById("canvas-score");
            let container = document.getElementById("singing-container");

            if (mode === 'fast') {
                let width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
                let num_phrases = Math.ceil(canvas.width / width);
                for (let i = 0; i < num_phrases; i++) {
                    if (container.scrollLeft >= i * width && container.scrollLeft < (i + 1) * width) {
                        container.scrollTo((i + 1) * width, 0);
                        break;
                    }
                }

            } else {
                if (container.scrollLeft < canvas.width - window.innerWidth) {
                    container.scrollTo(container.scrollLeft + canvas.width / 10.0, 0);
                }
            }
            this.enable_buttons(container, canvas);
        },
        enable_buttons(container, canvas) {
            if (container.scrollLeft > 0) {
                this.back_arrow_disabled = false;
            } else {
                this.back_arrow_disabled = true;
            }
            if (container.scrollLeft >= canvas.width - window.innerWidth) {
                this.next_arrow_disabled = true;
            } else {
                this.next_arrow_disabled = false;
            }
        },
        play_music() {

            let phrase = this.phrases['music'];
            let notes = [];
            for (let b in Object.keys(phrase)) {
                let beat = Object.keys(phrase)[b];
                for (let note in phrase[beat]['notes']) {
                    let dur = phrase[beat]['notes'][note][2];
                    if (dur == 1) {
                        dur = this.phrases["whole_duration"];
                    }
                    notes.push([phrase[beat]['notes'][note][1], dur]);
                }
            }

            this.midi = {
                'tracks': {
                    '0': {
                        'instrument': this.$data.instruments.harmonic.Piano,
                        'is_percussion': false,
                        'notes': notes,
                        'is_muted': this.muted,
                        'loudness': 0.8
                    }
                },
                'whole_duration': this.phrases['whole_duration'],
                'n_beats': Object.keys(this.phrases['music']),
            }

            let container = document.getElementById("singing-container");
            this.currentScroll = container.scrollLeft;

            this.play = true;
            this.playMusic = !this.playMusic;
            this.play_recording();
        },
        record() {
            var device = navigator.mediaDevices.getUserMedia({
                audio: true
            });
            device.then((stream) => {
                    // use this!
                    this.recorder = new MediaRecorder(stream);
                    this.recorder.ondataavailable = (e) => {
                        this.recorded_blob = new Blob([e.data], {
                            type: 'audio/mp3'
                        });
                        this.recorded = URL.createObjectURL(e.data);
                        let audio = document.getElementById('audio');
                        audio.src = this.recorded;
                    };

                    this.play_music();
                    this.recorder.start();
                }),
                this.recording = true;

        },
        on_stop_recording() {
            if (this.recorder !== null && this.recorder.state !== "inactive") {
                this.recorder.stop();
            }
            this.recording = false;
        },
        timer() {
            if (this.ct > 0) {
                let number = document.getElementById("singing-count-number");
                number.innerHTML = this.ct;
                this.ct = this.ct - 1;
            } else {
                clearInterval(this.counter);
                this.onCount = false;
                this.record();
            }
        },
        startCount() {
            this.onCount = true;
            this.ct = 3;
            this.counter = setInterval(this.timer, 1000);
        }
    },
};
</script>

<style>
.container {
    width: 100%;
    height: 100%;

    position: absolute;
}

.complete {
    position: absolute;
    right: 1rem;
    bottom: 1rem;
}

.edit {
    position: absolute;
    left: 5rem;
    top: 1rem;
}

.play-sing {
    position: absolute;
    left: 43%;
    bottom: 7%;
}

.record-sing {
    position: absolute;
    bottom: 7%;
    left: 52%;
}

.instrument-mute-sing {
    position: absolute;
    bottom: 6%;
    left: 43.5%;

    opacity: 8.0;
    border-radius: 50%;

    display: flex;
    justify-content: space-around;

    width: 1.5em !important;
    height: 1.5em;
    margin-left: 2em;

    z-index: 2;
}

.voice-mute-sing {
    position: absolute;
    bottom: 6%;
    left: 52.5%;

    opacity: 8.0;
    border-radius: 50%;

    display: flex;
    justify-content: space-around;

    width: 1.5em !important;
    height: 1.5em;
    margin-left: 2em;

    z-index: 2;
}

.instrument-mute-sing.muted {
    /* background: red;  */
}

.instrument-mute-sing>img {
    width: 1.5em !important;
}

.score-container {
    display: flex;
    align-self: center;
    flex-wrap: nowrap;
    align-items: center;
    align-content: center;
    justify-content: space-around;

    width: 100%;

    padding-top: 4%;
    height: 90%;
}

.lateral {
    width: 5%;
}

.rightbutton {
    margin-right: 3%;
}

.leftbutton {
    margin-left: 3%;
}

#back[disabled=true] {
    opacity: 0.7;
}

#forward[disabled=true] {
    opacity: 0.7;
}

.score {
    width: 80%;
    height: 100%;

    display: flex;
    align-self: center;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: space-around;

    /* display: inline_3-grid;
  grid-template-columns: 12.5% 12.5% 12.5% 12.5% 12.5% 12.5% 12.5% 12.5%;
  grid-template-rows: 33% 33% 33%; */
}

.beat-score {
    display: flex;
    align-self: center;
    justify-content: center;
}

.note {
    margin: 0 -1.2rem;
}

.beat-level-1 {
    margin-top: -45%;
}

.beat-level-2 {
    margin-top: -4em;
}

.beat-level-3 {
    margin-top: 35%;
}

.canvas {
    position: absolute;
    top: 0;

    width: 100%;
    height: 100%;

    z-index: -1;
}

.choose {
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 1em;
    height: 150%;
    padding: 1em;
}

.singing-counting {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: rgba(73, 64, 101, 0.4);

    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 10;
}

.singing-count-number {
    font-size: 10rem;
    font-family: Omnes;
    font-weight: bold;
    color: white;

}

.speed-bar {
    width: 15%;
    position: absolute;
    right: 7%;
    top: 7% !important;

}

#speedbarcoelho {
    position: fixed;
    right: 4%;
    top: 7%;
    height: 5%;
    float: right;
}

#speedbarcaracol {
    position: fixed;
    right: 22%;
    top: 7%;
    height: 5%;
    float: right;
}

input[type=range] {
    -webkit-appearance: none;
}

#Speed-Range-Sing {
    height: 5px;
    border-radius: 5px;
    margin-top: 7%;
    outline: none;
    filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));
    stroke: none;
    background: #009FE3;
}

#Speed-Range-Sing::-webkit-slider-thumb {
    -webkit-appearance: none;
    border: none;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background: #ffffff;
    margin-top: -13px;
}

#Speed-Range-Sing[type=range]::-ms-fill-upper {
    background: #ddd;
    border-radius: 10px;
}

#Speed-Range-Sing::before {
    -webkit-appearance: none;
    opacity: 0%;
}

@media only screen and (max-width: 686px) {
    .lateral {
        width: 2.7rem;
        height: 2.7rem;
    }

    .rightbutton {
        margin-right: 3%;
    }

    .edit {
        left: 4.5rem;
    }

    .note {
        margin: 0 -1rem;
        width: 4rem;
    }

    .choose {
        padding: 0.8rem;
    }

    .beat-level-2 {
        margin-top: -1em;
    }

    .beat-level-3 {
        margin-top: 37%;
    }

    .hidden {
        height: 5em;
        width: 2em;
        opacity: 0;
    }

    .score {
        width: 78%;
    }

    .singing-count-number {
        font-size: 10rem;
    }

}

@media only screen and (min-width: 1024px) {

    .lateral {
        width: 4.5rem;
        height: 4.5rem;
    }

    .edit {
        left: 6.5rem;
    }

    .note {
        margin: 0 -1.5rem;
        width: 7rem;
    }

    .score {
        width: 79%;
    }

    .singing-count-number {
        font-size: 30rem;
    }
}

@media only screen and (min-width: 1300px) {

    .lateral {
        width: 6rem;
        height: 6rem;
    }

    .edit {
        left: 7.5rem;
    }

    .note {
        margin: 0 -1.5rem;
        width: 9rem;
    }

    .hidden {
        height: 11.3em;
        width: 6em;
    }

    .singing-count-number {
        font-size: 30rem;
    }

}
</style>
